import { Sparkles } from 'lucide-react';
import { ClinicalInsightData } from '../../../../../types/live-insights';
import { useTranslation } from 'react-i18next';

interface Props {
    data: ClinicalInsightData;
}

export const InterventionSuggestionCard: React.FC<Props> = ({ data }) => {
    const { t } = useTranslation();
    return (
        <div className="group relative overflow-hidden rounded-xl bg-white/40 p-4 shadow-sm ring-1 ring-black/5 backdrop-blur-md transition-all hover:shadow-md hover:ring-black/10">
            {/* Soft indigo accent */}
            <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-indigo-400/60 to-violet-500/60" />

            <div className="flex items-start gap-3">
                <div className="mt-1 rounded-full bg-indigo-50 p-1.5 text-indigo-600">
                    <Sparkles className="h-4 w-4" />
                </div>
                <div className="flex-1 space-y-1">
                    <div className="flex items-center justify-between">
                        <h4 className="text-sm font-semibold text-slate-800 tracking-tight">
                            {data.title}
                        </h4>
                        <span className="text-xs font-medium uppercase tracking-wider text-slate-400">
                            {t('session.liveInsights.types.suggestion')}
                        </span>
                    </div>
                    <p className="text-xs leading-relaxed text-slate-600">
                        {data.content}
                    </p>
                </div>
            </div>
        </div>
    );
};
